import React, { useState, useEffect, useRef, useContext } from "react";
import { Paginator } from "primereact/paginator";
import * as Yup from "yup";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import {
  ArrearDelete,
  getArrearList,
  postArrearDelete,
  postArrearUpdate,
} from "./Services/PayrollService";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { TostMsg } from "../../../App";
// import { getEmployeeList } from "../EmployeeList/Service/employeeService";
const ArrearManagement = () => {
  const [ArrearManagementSummery, setArrearManagementSummery] = useState([]);
  const [ArrearManagementList, setArrearManagementList] = useState([]);
  const [arrearStatusList, setArrearStatusList] = useState([]);
  const [arrearTypesList, setArrearTypesList] = useState([]);
  const [EmployeeList, setEmployeeList] = useState([]);
  const [formonthList, setFormonthList] = useState([]);
  const [arrears, setArrears] = useState([]);
  const [nextId, setNextId] = useState(5);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const searchTimeout = useRef(null);
  const toaster = useContext(TostMsg);

  // Form fields
  const [formData, setFormData] = useState({
    EmployeeName: "",
    ArrearTypeName: "",
    month: "",
    Amount: "",
    ArrearStatusName: "Open",
    Taximpact: "Taxable",
    Reason: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const rup = (n) => (n ? `₹${n.toLocaleString("en-IN")}` : "—");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");

  useEffect(() => {
    getMasterData();
    GetEmployeeList();
  }, []);

  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }
    searchTimeout.current = setTimeout(() => {
      GetArrearList(1, rows);
      setFirst(0);
    }, 500);
    return () => clearTimeout(searchTimeout.current);
  }, [searchQuery, filterType, filterStatus]);

  const GetEmployeeList = async () => {
    let params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EpmId,
      IsDirectReportOrHierarchy: 0,
      EmployeeId: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsSuggestedOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
    };
    try {
      let res = await getEmployeeList(params);
      console.log(res.Data);
      setEmployeeList(res.Data);
    } catch (error) {
      console.error("Error fetching employee list:", error);
    }
  };

  const getMasterData = async () => {
    try {
      // setIsloading(true);

      const statusParams = {
        masterType: "ArrearStatus",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const typeParams = {
        masterType: "ArrearTypes",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };
      const formonthParams = {
        masterType: "formonth",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const [statusRes, typeResm, formonthRes] = await Promise.all([
        GetMasterTypeData(statusParams),
        GetMasterTypeData(typeParams),
        GetMasterTypeData(formonthParams),
      ]);

      setArrearStatusList(statusRes?.Data || []);
      setArrearTypesList(typeResm?.Data || []);
      setFormonthList(formonthRes?.Data || []);
    } catch (error) {
      // toster.current.error(ERROR_LIST?.MasterDataType);
    } finally {
      // setIsloading(false);
    }
  };

  const GetArrearList = async (page = 1, size = rows) => {
    // const typeData = arrearTypesList?.find(t => t.Name === filterType);
    // const statusData = arrearStatusList?.find(s => s.Name === filterStatus);

    let params = {
      ArrearId: 0,
      OrgId: userDetails?.OrgId,
      GUID: "",
      EmpId:0,
      Search: searchQuery || "",
      ArrearStatusId: filterStatus || "",
      ArrearTypeId: filterType || "",
      LoggedInEmpId: 0,
      PageNumber: page,
      PageSize: size,
    };
    try {
      let res = await getArrearList(params);
      setArrearManagementSummery(res?.Data?.ArrearDashboardDetails[0]);
      setArrears(res?.Data?.ArrearResponseDetails || []);
      setTotalRecords(
        res?.Data?.RecordCount ||
          res?.Data?.TotalRecords ||
          res?.Data?.TotalCount ||
          res?.Data?.ArrearResponseDetails?.length ||
          0,
      );
    } catch (error) {
      console.error("Error fetching arrear list:", error);
    }
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    const page = event.first / event.rows + 1;
    GetArrearList(page, event.rows);
  };

  const PostArrearUpdate = async () => {
    let params = {
      Id: 0,
      OrgId: userDetails?.OrgId,
      EmpId: 0,
      ArrearTypeId: 0,
      ForMonth: "",
      Amount: 0,
      ArrearStatusId: 0,
      Taximpact: "",
      Reason: "",
      PaidAmount: 0,
    };
    try {
      let res = await postArrearUpdate(params);
      console.log(res?.Data?.ArrearDashboardDetails[0]);
      setArrearManagementSummery(res?.Data?.ArrearDashboardDetails[0]);
      setArrears(res?.Data?.ArrearResponseDetails);
    } catch (error) {
      console.error("Error fetching arrear list:", error);
    }
  };

  const filteredData = arrears;

  // Calculate summaries (on current page)

  // Calculate summaries
  const openArrears = filteredData.filter(
    (a) => a.ArrearStatusName !== "Paid",
  ).length;
  const totalAmount = filteredData.reduce((sum, a) => sum + a.Amount, 0);
  const paidAmount = filteredData
    .filter((a) => a.ArrearStatusName === "Paid")
    .reduce((sum, a) => sum + a.Amount, 0);
  const monthPayable = filteredData
    .filter((a) => a.ArrearStatusName !== "Paid")
    .reduce((sum, a) => sum + a.Amount, 0);

  const renderList = () => {
    return filteredData.map((a) => {
      const statusClass =
        a.ArrearStatusName === "Open"
          ? "badge-pending"
          : a.ArrearStatusName === "Paid"
            ? "badge-paid"
            : "badge-locked";

      return (
        <tr key={a.id}>
          <td>
            <span style={{ fontWeight: 600 }}>{a.EmployeeName}</span>
            <br />
            <code style={{ fontSize: '10px', color: 'var(--brand)' }}>{a.EmpId}</code>
          </td>
          <td>
            <span
              className="badge badge-account"
              style={{ fontSize: "10.5px" }}
            >
              {a.ArrearTypeName}
            </span>
          </td>
          <td style={{ fontSize: "12px", color: "var(--text-muted)" }}>
            {a.ForMonth}
          </td>
          <td className="tr" style={{ fontWeight: 700 }}>
            {rup(a.Amount)}
          </td>
          <td
            style={{
              fontSize: "12px",
              color: "var(--text-muted)",
              maxWidth: "220px",
            }}
          >
            {a.Reason || "—"}
          </td>
          <td style={{ textAlign: "center" }}>
            <span className={`badge ${statusClass}`}>{a.ArrearStatusName}</span>
          </td>
          <td style={{ textAlign: "center" }}>
            <div
              style={{ display: "flex", gap: "4px", justifyContent: "center" }}
            >
              <button
                className="btn btn-light btn-sm"
                onClick={() => openEdit(a.Id)}
                title="Edit"
              >
                <i className="fa-solid fa-pen" style={{ fontSize: "10px" }}></i>
              </button>
              <button
                className="btn btn-light btn-sm"
                onClick={() => askDelete(a.Id)}
                title="Delete"
                style={{ color: "var(--danger)" }}
              >
                <i className="fa-solid fa-trash" style={{ fontSize: "10px" }}></i>
              </button>
            </div>
          </td>
        </tr>
      );
    });
  };

  // Yup Validation Schema
  const arrearValidationSchema = Yup.object().shape({
    EmployeeName: Yup.string().required("Employee is required"),
    ArrearTypeName: Yup.string().required("Arrear Type is required"),
    month: Yup.string().required("Month is required"),
    Amount: Yup.number()
      .typeError("Amount must be a number")
      .required("Amount is required")
      .positive("Amount must be positive"),
    ArrearStatusName: Yup.string().required("Status is required"),
    Taximpact: Yup.string().required("Tax Impact is required"),
    Reason: Yup.string(),
  });

  const clearForm = () => {
    setFormData({
      EmployeeName: "",
      ArrearTypeName: "",
      month: "",
      Amount: "",
      ArrearStatusName: "Open",
      Taximpact: "Taxable",
      Reason: "",
    });
    setFormErrors({});
  };

  const clearFieldError = (fieldName) => {
    setFormErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[fieldName];
      return newErrors;
    });
  };

  const openAdd = () => {
    setEditId(null);
    clearForm();
    setFormErrors({});
    setShowModal(true);
  };

  const openEdit = (id) => {
    const arrear = arrears.find((a) => a.id === id);
    if (!arrear) return;

    setEditId(id);
    setFormData({
      EmployeeName: `${arrear.EmployeeName}|${arrear.EmpId}`,
      ArrearTypeName: arrear.ArrearTypeName,
      month: arrear.ForMonth,
      Amount: arrear.Amount,
      ArrearStatusName: arrear.ArrearStatusName,
      Taximpact: arrear.Taximpact,
      Reason: arrear.Reason || "",
    });
    setFormErrors({});
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const saveArrear = async () => {
    try {
      // Clear previous errors
      setFormErrors({});

      // Validate form data
      await arrearValidationSchema.validate(formData, { abortEarly: false });

      const {
        EmployeeName,
        ArrearTypeName,
        month,
        Amount,
        ArrearStatusName,
        Taximpact,
        Reason,
      } = formData;

      // Parse employee and type IDs
      const [empName, empId] = EmployeeName.includes("|")
        ? EmployeeName.split("|")
        : [EmployeeName, ""];

      // Find the type ID from arrearTypesList
      const typeData = arrearTypesList?.find((t) => t.Name === ArrearTypeName);
      const typeId = typeData?.Id || 0;

      // Find the status ID from arrearStatusList
      const statusData = arrearStatusList?.find(
        (s) => s.Name === ArrearStatusName,
      );
      const statusId = statusData?.Id || 0;

      // Find the employee data
      const employeeData = EmployeeList?.find((e) => e.EmploymentId === empId);
      const empEmpId = employeeData?.EmpId || 0;

      // Prepare params for API
      let params = {
        Id: editId || 0,
        OrgId: userDetails?.OrgId || 0,
        EmpId: empEmpId,
        ArrearTypeId: typeId,
        ForMonth: month,
        Amount: parseFloat(Amount),
        ArrearStatusId: statusId,
        Taximpact: Taximpact,
        Reason: Reason || "",
        PaidAmount: 0,
      };

      // Call API
      const res = await postArrearUpdate(params);

      if (res?.StatusCode === 2000) {
        toaster.current.success(`Arrear ${params.Id ? "updated" : "added"} successfully`);
        setArrearManagementSummery(
          res?.Data?.ArrearDashboardDetails?.[0] || {},
        );
        setArrears(res?.Data?.ArrearResponseDetails || []);
        GetArrearList();
        closeModal();
      } else {
        toaster.current.error(res?.Message || "Error saving arrear. Please try again.");
      }
    } catch (error) {
      if (error.inner) {
        // Yup validation error with multiple errors
        const errors = {};
        error.inner.forEach((err) => {
          errors[err.path] = err.message;
        });
        setFormErrors(errors);
      } else if (error.name === "ValidationError") {
        setFormErrors({ form: error.message });
      } else {
        console.error("Error saving arrear:", error);
        toaster.current.error("Error saving arrear. Please check the console.");
        setFormErrors({
          form: "Error saving arrear. Please check the console.",
        });
      }
    }
  };

  const askDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };



  const confirmDelete = async () => {
   
    try {
      const params = {
        RequestId: deleteId,
      };

      const result = await postArrearDelete(params);
      if (result.StatusCode === 2000) {
        // alert('Loan deleted successfully');
        toaster.current.success("Arrear deleted successfully");
        setShowDeleteModal(false);
        setDeleteId(null);
        await GetArrearList();
      } else {
        // alert(result.error || 'Error deleting loan');
        toaster.current.error("Error deleting arrear");

      }
    } catch (error) {
      console.error("Error deleting arrear:", error);
      // alert('Error deleting arrear');
    }
  };

  useEffect(() => {
    // React handles re-render automatically
  }, [searchQuery, filterType, filterStatus, arrears]);

  const exportToCSV = () => {
    if (!filteredData.length) {
      console.log("No data to export");
      return;
    }

    const headers = [
      "Employee",
      "Employee ID",
      "Arrear Type",
      "Month",
      "Amount",
      "Status",
      "Tax",
      "Notes",
    ];

    const rows = filteredData.map((a) => [
      `"${a.EmployeeName}"`,
      `"${a.EmpId}"`,
      `"${a.ArrearTypeName}"`,
      `"${a.month}"`,
      a.Amount,
      `"${a.ArrearStatusName}"`,
      `"${a.Taximpact}"`,
      `"${a.Reason || ""}"`,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "arrears_data.csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container-fluid">
      <div className="form-head d-flex flex-wrap align-items-center page-head mb-0">
        <div className="me-auto">
          <h2 className="font-w600 mb-0">Arrear Management</h2>
          <p>
            {" "}
            Salary arrears from revision, backdated increments or missed
            payments. Open/partial records flow into payroll Step 4.
          </p>
        </div>
        <div className="rightside-tabs">
          <div className="topbar-actions">
            <button
              className="bbtn-og btn-og-secondary btn-og-sm"
              onClick={exportToCSV}
            >
              Export
            </button>
            <button className="btn-og theme-color btn-og-sm" onClick={openAdd}>
              Add Arrear
            </button>
          </div>
        </div>
      </div>
      <div className="page-content">
        {/* SUMMARY CARDS */}
        <div className="arrear-summarycards">
          <div className="blocks">
            <div className="block-div1">Open Arrears</div>
            <div className="block-div2" id="sum-open">
              {ArrearManagementSummery?.OpenArrears}
            </div>
          </div>
          <div className="blocks">
            <div className="block-div1">Total Arrear Amount</div>
            <div className="block-div2">
              {rup(ArrearManagementSummery?.TotalArrearAmount || 0)}
            </div>
          </div>
          <div className="blocks">
            <div className="block-div1">Paid Out</div>
            <div className="block-div2">
              {rup(ArrearManagementSummery?.PaidOut || 0)}
            </div>
          </div>
          <div className="blocks">
            <div className="block-div1">This Month Payable</div>
            <div className="block-div2">
              {rup(ArrearManagementSummery?.ThisMonthPayable || 0)}
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="card" style={{ overflow: "hidden" }}>
          <div className="toolbar">
            <input
              ArrearTypeName="text"
              className="form-control"
              placeholder="Search employee…"
              style={{ width: "200px" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div className="toolbar-sep"></div>
            <select
              className="form-select"
              style={{ width: "160px" }}
              value={filterType}
              onChange={(e) => setFilterType(e.target.value?.toString())}
            >
              <option value="">All Types</option>
              {arrearTypesList?.map((type) => (
                <option key={type.Id} value={type.Id}>
                  {type.Name}
                </option>
              ))}
            </select>
            <select
              className="form-select"
              style={{ width: "130px" }}
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value?.toString())}
            >
              <option value="">All Status</option>
              {arrearStatusList?.map((status) => (
                <option key={status.Id} value={status.Id}>
                  {status.Name}
                </option>
              ))}
            </select>
            <div className="toolbar-spacer"></div>
            <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>
              {totalRecords} records
            </span>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table className="mgmt-tbl">
              <thead>
                <tr>
                  <th>Employee</th>
                  <th>Arrear Type</th>
                  <th>For Month</th>
                  <th className="tr">Amount</th>
                  <th>Reason / Notes</th>
                  <th style={{ textAlign: "center" }}>Status</th>
                  <th style={{ textAlign: "center" }}>Actions</th>
                </tr>
              </thead>
              <tbody>{renderList()}</tbody>
              <tfoot>
                <tr>
                  <td colSpan="3">PAGE TOTAL</td>
                  <td className="tr" style={{ fontWeight: 700 }}>
                    {rup(totalAmount)}
                  </td>
                  <td colSpan="3">—</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <Paginator
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            rowsPerPageOptions={[10, 20, 50, 100]}
            onPageChange={onPageChange}
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          />
        </div>
      </div>

      {/* ADD/EDIT MODAL */}
      {showModal && (
        <div className="mo open" onClick={closeModal}>
          <div className="mb" onClick={(e) => e.stopPropagation()}>
            <div className="mh">
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "8px",
                  background: "var(--brand-soft)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--brand)",
                }}
              >
                <i className="pi pi-refresh" style={{ fontSize: "16px" }}></i>
              </div>
              <h6
                id="formTitle"
                style={{ margin: 0, fontSize: "14px", fontWeight: 700 }}
              >
                {editId ? "Edit Arrear" : "Add Arrear"}
              </h6>
              <button
                style={{
                  marginLeft: "auto",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#888",
                  lineHeight: 1,
                }}
                onClick={closeModal}
              >
                ×
              </button>
            </div>

            <div className="mbody">
              {formErrors.form && (
                <div
                  style={{
                    padding: "10px",
                    marginBottom: "12px",
                    background: "#fee2e2",
                    border: "1px solid var(--danger)",
                    borderRadius: "6px",
                    color: "var(--danger)",
                    fontSize: "13px",
                  }}
                >
                  {formErrors.form}
                </div>
              )}
              <div className="fsec">Employee &amp; Arrear Details</div>
              <div className="fg2">
                <div>
                  <label className="form-label">
                    Employee<span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <select
                    className={`form-select w-100 `}
                    value={formData.EmployeeName}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        EmployeeName: e.target.value,
                      });
                      clearFieldError("EmployeeName");
                    }}
                    style={
                      formErrors.EmployeeName
                        ? { borderColor: "var(--danger)" }
                        : {}
                    }
                  >
                    <option value="">Select…</option>
                    {EmployeeList?.map((employee) => (
                      <option
                        key={employee.Id}
                        value={`${employee.FullName}|${employee.EmploymentId}`}
                      >
                        {employee.FullName} ({employee.EmploymentId})
                      </option>
                    ))}
                  </select>
                  {formErrors.EmployeeName && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.EmployeeName}
                    </small>
                  )}
                </div>
                <div>
                  <label className="form-label">
                    Arrear Type{" "}
                    <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <select
                    className={`form-select w-100 `}
                    value={formData.ArrearTypeName}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        ArrearTypeName: e.target.value,
                      });
                      clearFieldError("ArrearTypeName");
                    }}
                    style={
                      formErrors.ArrearTypeName
                        ? { borderColor: "var(--danger)" }
                        : {}
                    }
                  >
                    <option value="">Select…</option>
                    {arrearTypesList?.map((type) => (
                      <option key={type.Id} value={type.Name}>
                        {type.Name}
                      </option>
                    ))}
                  </select>
                  {formErrors.ArrearTypeName && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.ArrearTypeName}
                    </small>
                  )}
                </div>
                <div>
                  <label className="form-label">
                    For Month <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <select
                    className={`form-select w-100`}
                    value={formData.month}
                    onChange={(e) => {
                      setFormData({ ...formData, month: e.target.value });
                      clearFieldError("month");
                    }}
                    style={
                      formErrors.month ? { borderColor: "var(--danger)" } : {}
                    }
                  >
                    <option value="">Select…</option>
                    {formonthList?.map((fm) => (
                      <option key={fm.Id} value={fm.Name}>
                        {fm.Name}
                      </option>
                    ))}
                  </select>
                  {formErrors.month && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.month}
                    </small>
                  )}
                </div>
                <div>
                  <label className="form-label">
                    Amount (₹) <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control w-100 ${formErrors.Amount ? "is-invalid" : ""}`}
                    value={formData.Amount}
                    onChange={(e) => {
                      setFormData({ ...formData, Amount: e.target.value });
                      clearFieldError("Amount");
                    }}
                    placeholder="0"
                    style={
                      formErrors.Amount ? { borderColor: "var(--danger)" } : {}
                    }
                  />
                  {formErrors.Amount && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.Amount}
                    </small>
                  )}
                </div>
                <div>
                  <label className="form-label">Status</label>
                  <select
                    className={`form-select w-100 `}
                    value={formData.ArrearStatusName}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        ArrearStatusName: e.target.value,
                      });
                      clearFieldError("ArrearStatusName");
                    }}
                    style={
                      formErrors.ArrearStatusName
                        ? { borderColor: "var(--danger)" }
                        : {}
                    }
                  >
                    {arrearStatusList?.map((status) => (
                      <option key={status.Id} value={status.Name}>
                        {status.Name}
                      </option>
                    ))}
                  </select>
                  {formErrors.ArrearStatusName && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.ArrearStatusName}
                    </small>
                  )}
                </div>
                <div>
                  <label className="form-label">Tax Impact</label>
                  <select
                    className={`form-select w-100`}
                    value={formData.Taximpact}
                    onChange={(e) => {
                      setFormData({ ...formData, Taximpact: e.target.value });
                      clearFieldError("Taximpact");
                    }}
                    style={
                      formErrors.Taximpact
                        ? { borderColor: "var(--danger)" }
                        : {}
                    }
                  >
                    <option>Taxable</option>
                    <option>Non-Taxable</option>
                  </select>
                  {formErrors.Taximpact && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.Taximpact}
                    </small>
                  )}
                </div>
                <div style={{ gridColumn: "1 / -1" }}>
                  <label className="form-label">Reason / Notes</label>
                  <textarea
                    className="form-control w-100"
                    rows="2"
                    value={formData.Reason}
                    onChange={(e) => {
                      setFormData({ ...formData, Reason: e.target.value });
                      clearFieldError("Reason");
                    }}
                    placeholder="Reason for arrear, HR approval ref…"
                    style={{ resize: "vertical" }}
                  />
                </div>
              </div>
            </div>

            <div className="mfoot">
              <button className="btn btn-light" onClick={closeModal}>
                Cancel
              </button>
              <button className="btn btn-brand" onClick={saveArrear}>
                <i className="pi pi-check" style={{ marginRight: "6px" }}></i>
                {editId ? "Save Changes" : "Add Arrear"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DELETE CONFIRM MODAL */}
      {showDeleteModal && (
        <div className="mo open" onClick={() => setShowDeleteModal(false)}>
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "400px",
              padding: "24px",
              boxShadow: "0 24px 64px rgba(0,0,0,.18)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "12px",
              }}
            >
              <div
                style={{
                  width: "34px",
                  height: "34px",
                  background: "#fee2e2",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--danger)",
                }}
              >
                <i className="pi pi-trash" style={{ fontSize: "18px" }}></i>
              </div>
              <h6 style={{ margin: 0, fontWeight: 700 }}>Delete Arrear</h6>
            </div>
            <p
              style={{
                fontSize: "13px",
                color: "var(--text-mid)",
                margin: "0 0 18px",
              }}
            >
              Delete arrear record for{" "}
              {arrears.find((a) => a.id === deleteId)?.EmployeeName}?
            </p>
            <div
              style={{
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
              }}
            >
              <button
                className="btn btn-light"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-brand"
                style={{
                  background: "var(--danger)",
                  borderColor: "var(--danger)",
                }}
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* CSS Styles */}
      <style jsx>{`
        .mgmt-tbl {
          width: 100%;
          border-collapse: collapse;
          font-size: 12.5px;
        }
        .mgmt-tbl thead th {
          background: #f8f9fa;
          color: var(--text-mid);
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.4px;
          padding: 9px 14px;
          border-bottom: 1px solid var(--border);
          white-space: nowrap;
        }
        .mgmt-tbl thead th.tr {
          text-align: right;
        }
        .mgmt-tbl tbody td {
          padding: 10px 14px;
          border-bottom: 1px solid #f0f2f5;
          vertical-align: middle;
        }
        .mgmt-tbl tbody td.tr {
          text-align: right;
          font-variant-numeric: tabular-nums;
        }
        .mgmt-tbl tbody tr:hover td {
          background: #fdf8f6;
        }
        .mgmt-tbl tfoot td {
          padding: 9px 14px;
          background: #fff7f5;
          font-weight: 700;
          border-top: 2px solid var(--brand);
        }
        .mgmt-tbl tfoot td.tr {
          text-align: right;
        }

        .mo {
          display: none;
          position: fixed;
          inset: 0;
          z-index: 1000;
          background: rgba(0, 0, 0, 0.48);
          align-items: center;
          justify-content: center;
        }
        .mo.open {
          display: flex;
        }
        .mb {
          background: #fff;
          border-radius: 12px;
          width: 560px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18);
        }
        .mh {
          padding: 16px 22px;
          border-bottom: 1px solid var(--border);
          display: flex;
          align-items: center;
          gap: 10px;
          position: sticky;
          top: 0;
          background: #fff;
          z-index: 1;
        }
        .mh h6 {
          margin: 0;
          font-size: 14px;
          font-weight: 700;
        }
        .mbody {
          padding: 22px;
        }
        .mfoot {
          padding: 12px 22px;
          border-top: 1px solid var(--border);
          display: flex;
          justify-content: flex-end;
          gap: 8px;
          background: #fafbfc;
          border-radius: 0 0 12px 12px;
        }
        .fg2 {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
        }
        .fsec {
          font-size: 11px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.6px;
          color: var(--text-muted);
          margin: 18px 0 10px;
          padding-bottom: 6px;
          border-bottom: 1px solid var(--border);
        }
        .fsec:first-child {
          margin-top: 0;
        }

        /* Paginator Styles */
        :global(.p-paginator) {
          padding: 8px 14px;
          background: #fff;
          border-top: 1px solid #f0f2f5;
          justify-content: flex-end;
          font-family: inherit;
        }
        :global(.p-paginator .p-paginator-current) {
          margin-right: auto;
          font-size: 12px;
          color: var(--text-muted);
        }
        :global(.p-paginator .p-paginator-pages .p-paginator-page) {
          min-width: 28px;
          height: 28px;
          font-size: 12px;
          border-radius: 4px;
        }
        :global(.p-paginator .p-paginator-pages .p-paginator-page.p-highlight) {
          background: var(--brand-soft);
          color: var(--brand);
        }
        :global(.p-paginator .p-link) {
          width: 28px;
          height: 28px;
          min-width: 28px;
        }
      `}</style>
    </div>
  );
};

export default ArrearManagement;
